import { Link } from 'react-router-dom';
import { getAdminInfo } from '../../helper';

const SessionContainer = ({
  session,
  numStudentsInSession,
  students,
  sessionCount,
  handleClickOpen,
}) => {
  const admin = getAdminInfo();
  return (
    <div
      key={`session_${session.id}`}
      className='rounded-md bg-secondary-300 p-2 shadow'
    >
      <div className=''>
        <div className='text-md pb-2 font-semibold text-neutral-500'>
          {Number(admin['admin_level']) < 9 ? (
            session.session
          ) : (
            <span>
              {session.session} ({numStudentsInSession})
            </span>
          )}
        </div>

        <div>
          <ol className='list-inside list-decimal'>
            {students.map(student => {
              if (student.student_session_time == session.id) {
                sessionCount++;

                let textHighlight = 'text-inherit';
                if (
                  student.student_preferred_session_time &&
                  Number(student.student_preferred_session_time) !==
                    Number(session.id)
                )
                  textHighlight = 'text-rose-700';
                return (
                  <li key={`student_${student.student_id}`} className='text-md'>
                    <Link
                      onClick={() => handleClickOpen(student)}
                      className={`nameLink ${textHighlight}`}
                    >
                      {student.student_first_name} {student.student_last_name}
                    </Link>
                  </li>
                );
              }
            })}
          </ol>
        </div>
      </div>

      <div className='spacer'></div>
    </div>
  );
};

export default SessionContainer;
